import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Media, Icon, Progress} from 'kpc';

var _$tmp0 = {
    'type': 'circle',
    'size': 'mini',
    'percent': 68,
    'status': 'normal'
};
var _$tmp1 = {
    'type': 'circle',
    'size': 'mini',
    'percent': 28,
    'status': 'normal'
};
var _$tmp2 = {
    'className': 'ion-alert-circled'
};
var _$tmp3 = {
    'className': 'k-icon-visible'
};
var _$tmp4 = {
    'className': 'k-icon-download'
};
var _$tmp5 = {
    'className': 'ion-ios-play'
};
var _$tmp6 = {
    'className': 'ion-ios-play'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Media, {
            'name': '转码中.mp4',
            'type': 'video',
            'status': 'loading',
            'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['loading'] = function($super, media) {
                            return (
                                _$ce(2, 'div', (
                                    _$cc(Progress, _$tmp0)
                                ), 2, 'media-demo-slots-progress')
                            );
                        }),
                        (__$blocks['loading'] = function($super, data) {
                            var block = $blocks['loading'];
                            var callBlock = function() {
                                return _$blocks['loading'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Media, {
            'name': '转码中.mp4',
            'type': 'video',
            'status': 'loading',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['loading'] = function($super, media) {
                            return (
                                _$ce(2, 'div', (
                                    _$cc(Progress, _$tmp1)
                                ), 2, 'media-demo-slots-progress')
                            );
                        }),
                        (__$blocks['loading'] = function($super, data) {
                            var block = $blocks['loading'];
                            var callBlock = function() {
                                return _$blocks['loading'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Media, {
            'name': '封面加载失败.png',
            'type': 'image',
            'status': 'error',
            'src': 'https://example.com/broken.png',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['error'] = function($super, media) {
                            return (
                                _$ce(2, 'div', [
                                    _$cc(Icon, _$tmp2),
                                    _$ce(2, 'span', media.resolvedType === 'image' ? '图片不可用' : '加载失败', 0)
                                ], 4, 'media-demo-slots-error')
                            );
                        }),
                        (__$blocks['error'] = function($super, data) {
                            var block = $blocks['error'];
                            var callBlock = function() {
                                return _$blocks['error'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Media, {
            'name': '播客转码中.mp3',
            'type': 'audio',
            'status': 'loading',
            'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['loading'] = function($super, media) {
                            return (
                                _$ce(2, 'span', '42%', 16, 'media-demo-slots-audio-loading')
                            );
                        }),
                        (__$blocks['loading'] = function($super, data) {
                            var block = $blocks['loading'];
                            var callBlock = function() {
                                return _$blocks['loading'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Media, {
            'name': '播客资源失效.mp3',
            'type': 'audio',
            'status': 'error',
            'src': 'https://example.com/broken-audio.mp3',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['error'] = function($super, media) {
                            return (
                                _$ce(2, 'span', '已失效', 16, 'media-demo-slots-audio-error')
                            );
                        }),
                        (__$blocks['error'] = function($super, data) {
                            var block = $blocks['error'];
                            var callBlock = function() {
                                return _$blocks['error'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Media, {
            'name': '海边步道.jpg',
            'type': 'image',
            'status': 'done',
            'src': 'https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=640&q=80',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['mask'] = function($super, media) {
                            return (
                                _$ce(2, 'div', [
                                    _$ce(2, 'button', (
                                        _$cc(Icon, _$tmp3)
                                    ), 2, 'media-demo-slots-mask-button', {
                                        'type': 'button',
                                        'disabled': !media.canPreview,
                                        'ev-click': media.preview
                                    }),
                                    _$cc(Icon, _$tmp4)
                                ], 4, 'media-demo-slots-mask')
                            );
                        }),
                        (__$blocks['mask'] = function($super, data) {
                            var block = $blocks['mask'];
                            var callBlock = function() {
                                return _$blocks['mask'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Media, {
            'name': '产品预告.mp4',
            'type': 'video',
            'status': 'done',
            'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['mask'] = function($super, media) {
                            return (
                                _$ce(2, 'div', (
                                    _$ce(2, 'button', (
                                        _$cc(Icon, _$tmp5)
                                    ), 2, 'media-demo-slots-mask-button', {
                                        'type': 'button',
                                        'disabled': !media.canPreview,
                                        'ev-click': media.preview
                                    })
                                ), 2, 'media-demo-slots-mask')
                            );
                        }),
                        (__$blocks['mask'] = function($super, data) {
                            var block = $blocks['mask'];
                            var callBlock = function() {
                                return _$blocks['mask'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Media, {
            'name': '播客片段.mp3',
            'type': 'audio',
            'status': 'done',
            'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['mask'] = function($super, media) {
                            return (
                                _$ce(2, 'div', (
                                    _$ce(2, 'button', (
                                        _$cc(Icon, _$tmp6)
                                    ), 2, 'media-demo-slots-mask-button', {
                                        'type': 'button',
                                        'disabled': !media.canPreview,
                                        'ev-click': media.preview
                                    })
                                ), 2, 'media-demo-slots-mask')
                            );
                        }),
                        (__$blocks['mask'] = function($super, data) {
                            var block = $blocks['mask'];
                            var callBlock = function() {
                                return _$blocks['mask'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 4, 'media-demo-slots');
};